// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1bdyD","emails":"CreateEditClinics_emails__1UyPE","emailTagLabel":"CreateEditClinics_emailTagLabel__RJtRZ"};